const createUploadPathForResult = (result) =>
  `uploads/${result?.project?._id}/${result?._id}/${result?.device?.deviceName}/${result?.test?.testSubType?.type}/uploads/`;

const createUploadPathForProject = (projectId, companyId) => `uploads/${companyId}/${projectId}/Images/`;

export { createUploadPathForResult, createUploadPathForProject };
